import { SET_FILTER_STATUS, SET_SEARCH_TXT, SET_TIME_FRAME } from "../actions/types";

const initialState = {
    searchTxt:"",
    status:-1,
    timeframe:"week"
}
export default (state = initialState, { type, payload }) => {


    switch (type) {
        case SET_SEARCH_TXT:
            return { ...state,searchTxt: payload};
        case SET_FILTER_STATUS:
            return { ...state,status: payload};
        case SET_TIME_FRAME:
            return { ...state,timeframe: payload};
        default:
            return state;
    }
};